export const ANNUAL_DISCLAIMER =
  "By switching to annual billing, you will be charged immediately for a full year subscription. " +
  "Your account will receive a prorated credit for any unused portion of your current monthly billing period. " +
  "Your subscription will automatically renew annually until canceled.";

export const MONTHLY_DISCLAIMER =
  "By switching to monthly billing, you will be charged immediately for your first monthly subscription. " +
  "Your account will receive a prorated credit for any unused portion of your current annual billing period. " +
  "Your subscription will automatically renew monthly until canceled.";